import React from 'react';
import isEmpty from 'lodash/isEmpty';
import findKey from 'lodash/findKey';

import pricing from 'Containers/StaticSearch/games-under-pricing';
import GamesUnderBanner from 'Components/Sales/GamesUnderBanner';

const PreviewGamesUnderBanner = ({ advert }) => {
  if (isEmpty(advert)) return false;

  const firstAppearsOn = findKey(advert.appears_on, value => value === true);

  return (
    <section className="container" style={{ marginTop: '3rem' }}>
      <div className="games-under-banners section-margin three-banners">
        <GamesUnderBanner
          advertOverride={advert}
          type="left"
          appearsOn={firstAppearsOn}
          to="games-under/5"
          priceUnder={pricing['5'].max}
        />
        <GamesUnderBanner
          advertOverride={advert}
          type="middle"
          appearsOn={firstAppearsOn}
          to="games-under/10"
          priceUnder={pricing['10'].max}
        />
        <GamesUnderBanner
          advertOverride={advert}
          type="right"
          appearsOn={firstAppearsOn}
          to="games-under/20"
          priceUnder={pricing['20'].max}
        />
      </div>
    </section>
  );
};

export default PreviewGamesUnderBanner;
